<template>
  <div >
    <el-dialog  title="新增车辆" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"
    :visible="addVehicleFlag" width="1000px" center  append-to-body>
      <div>
         <el-form :inline="true" :model="addFrom" ref="addFrom" :rules="rules" class="demo-form-inline yanzheng jiaoyan" label-width="130px" size="mini" v-if="addVehicleFlag">
            <div class="inpBox">
              <el-form-item label="车牌号:" prop="vhcNo">
                <el-input placeholder="" @blur="CPHfn()"  v-model.trim="addFrom.vhcNo" maxlength="20"></el-input>
              </el-form-item>
              <el-form-item label="车牌颜色:" class="is-required" prop="noColour">
                <el-select placeholder="请选择" value-key="id" v-model="addFrom.noColour" >
                  <el-option v-for="(item) in clys" :key="item.id" :label="item.colourName" :value="item" v-if="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="车辆类型:" class="is-required" prop="vhcType">
                <el-select placeholder="请选择" value-key="id" v-model="addFrom.vhcType" @change="vhcTypeChange">
                  <el-option v-for="item in vehicleT" :key="item.id" :label="item.name" :value="item" v-if="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="挂车牌号:" prop="trailerNo" v-if="trailerNoIsShow">
                <el-input placeholder="" v-model.trim="addFrom.trailerNo" maxlength="20"></el-input>
              </el-form-item>
              <el-form-item label="挂车车型:" prop="vehicleModelId" v-if="addFrom.trailerNo">
                <el-select placeholder="请选择" filterable v-model="addFrom.vehicleModelId" @change="vhcModelChange">
                  <el-option v-for="item in vhcModelList" :key="item.id" :label="item.modelName" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="车长:" prop="vhcLength"  v-if="addFrom.trailerNo">
                <el-select placeholder="请选择" filterable v-model="addFrom.vhcLength">
                  <el-option v-for="(item,index) in vhcLongList" :key="index" :label="item.longName" :value="item.longName"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="能源类型:" class="is-required" prop="energy">
                <el-select placeholder="请选择" value-key="id" v-model="addFrom.energy" >
                  <el-option v-for="(item,index) in NYtype" :key="index" :label="item.energyName" :value="item"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="车辆所属:" prop="vehicleClassify">
                <el-select placeholder="请选择" v-model="addFrom.vehicleClassify" @change="classifyChange">
                  <el-option v-for="item in vehicleSS" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="所属单位/个人:" prop="vehicleTenant" v-if="addFrom.vehicleClassify==1" key="1">
                <el-select placeholder="请选择" filterable allow-create remote reserve-keyword :remote-method="remoteMethod"
                default-first-option v-model="addFrom.vehicleTenant" value-key="tenantCode" >
                  <el-option v-for="(item,index) in ssdw" :key="index" :label="item.tenantName" :value="item"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="所属单位/个人:" prop="vehicleTenantName" v-if="addFrom.vehicleClassify==2" key="2">
                <el-input placeholder="" v-model.trim="addFrom.vehicleTenantName" maxlength="11"></el-input>
              </el-form-item>
              <el-form-item label="使用性质:" prop="purpose">
                <el-select placeholder="请选择" value-key="id" filterable allow-create default-first-option v-model="addFrom.purpose">
                  <el-option v-for="item in clyt" :key="item.id" :label="item.name" :value="item" v-if="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="排放标准:" prop="standards">
                <el-select placeholder="请选择" value-key="id" v-model="addFrom.standards">
                  <el-option v-for="item in pfbz" :key="item.id" :label="item.name" :value="item" v-if="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="总质量(吨):" :rules="[{ required: isBitian, message: '请输入总质量', trigger: 'blur' } ]">
                <el-input v-model.trim="addFrom.vhcQuality" v-number-input.float="3" maxlength="11"></el-input>
              </el-form-item>
              <el-form-item label="整备质量(吨):" :rules="[{ required: isBitian, message: '请输入整备质量', trigger: 'blur' } ]">
                <el-input v-model.trim="addFrom.curbWeight" v-number-input.float="3" maxlength="11"></el-input>
              </el-form-item>
              <el-form-item label="载重(吨):" :rules="[{ required: isBitian, message: '请输入载重', trigger: 'blur' } ]">
                <el-input v-model.trim="addFrom.weight" v-number-input.float="3" maxlength="11"></el-input>
              </el-form-item>
              <el-form-item label="车辆识别代号:" prop="vhcVinNo">
                <el-input placeholder="" maxlength="18" v-model.trim="addFrom.vhcVinNo"></el-input>
              </el-form-item>
              <el-form-item label="发动机号:" prop="vhcEngineNo">
                <el-input placeholder="" maxlength="17" v-model.trim="addFrom.vhcEngineNo"></el-input>
              </el-form-item>
              <el-form-item label="道路运输证号:" prop="transportNo">
                <el-input placeholder="" maxlength="17" v-model.trim="addFrom.transportNo"></el-input>
              </el-form-item>
              <el-form-item label="发证机关:" prop="issueAuthority">
                <el-input placeholder="" maxlength="17" v-model.trim="addFrom.issueAuthority"></el-input>
              </el-form-item>
              <el-form-item label="车辆品牌:" prop="brandModel">
                <el-input placeholder="" maxlength="30" v-model.trim="addFrom.brandModel"></el-input>
              </el-form-item>
              <el-form-item label="发证日期:"  :rules="[{ required: isBitian, message: '请选择发证日期', trigger: 'blur' } ]">
                <el-date-picker
                  v-model="addFrom.issueDate"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                  type="date"
                  placeholder="选择日期时间"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="注册日期:"
                :rules="[{ required: isBitian, message: '请选择注册日期', trigger: 'blur' } ]"  >
                <el-date-picker
                  v-model="addFrom.registerDate"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                  type="date"
                  placeholder="选择日期时间"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="长(米):" prop="vhcLongNameChang">
                <el-input placeholder="" maxlength="18" v-model.trim="addFrom.vhcLongNameChang" v-number-input.float="3"></el-input>
              </el-form-item>
              <el-form-item label="宽(米):" prop="vhcLongNamekuan">
                <el-input placeholder="" maxlength="18" v-model.trim="addFrom.vhcLongNamekuan" v-number-input.float="3"></el-input>
              </el-form-item>
              <el-form-item label="高(米):" prop="vhcLongNameGao">
                <el-input placeholder="" maxlength="18" v-model.trim="addFrom.vhcLongNameGao" v-number-input.float="3"></el-input>
              </el-form-item>
              <el-form-item label="道运证许可号:" prop="businessLicenseNo" label-width="">
                <el-input placeholder="" maxlength="17" v-model.trim="addFrom.businessLicenseNo"></el-input>
              </el-form-item>
              <el-form-item label="行驶证有效期:" :rules="[{ required: isBitian, message: '请选择行驶证有效期', trigger: 'blur' } ]" label-width="">
                <el-date-picker
                  v-model="addFrom.drivingExpiringDate"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                  type="date"
                  placeholder="选择日期时间"
                  :picker-options="pickerOptionsB"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="行驶证报废日期:" :rules="[{ required: isBitian, message: '请选择行驶证报废日期', trigger: 'blur' } ]"label-width="">
                <el-date-picker
                  v-model="addFrom.scrapTime"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期时间"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="道运证发证日期:" :rules="[{ required: isBitian, message: '请选择道运证发证日期', trigger: 'blur' } ]" label-width="">
                <el-date-picker
                  v-model="addFrom.businessStartTime"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期时间"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="运输证有效期:"  :rules="[{ required: isBitian, message: '请选择运输证有效期', trigger: 'blur' } ]" label-width="">
                <el-date-picker
                  v-model="addFrom.businessExpiringDate"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                  type="date"
                  placeholder="选择日期时间"
                ></el-date-picker>
              </el-form-item>
              <div class="addressBox" v-if="isBitian">
                <h4 class="title" style="margin-left: 20px;">
                  <span><i class="fa fa-picture-o iconFont" aria-hidden="true"></i>证件信息</span>
                </h4>
              </div>
              <div class="box" v-if="newImgFlag&&isBitian" style="margin-left: 20px;">
                <div class="imgBox">
                  <uploadImg :img='img' @remove ='handleRemove' @change ='imgPreview'></uploadImg>
                  <h6>行驶证(正页)</h6>
                </div>
                <div class="imgBox">
                  <uploadImg :img='img1' @remove ='handleRemove1' @change ='imgPreview1'></uploadImg>
                  <h6>行驶证(副页)</h6>
                </div>
                <div class="imgBox">
                  <uploadImg :img='img2' @remove ='handleRemove2' @change ='imgPreview2'></uploadImg>
                  <h6>道路运输证(正页)</h6>
                </div>
                <!-- <div class="imgBox">
                  <uploadImg :img='img4' @remove ='handleRemove4' @change ='imgPreview4'></uploadImg>
                  <h6>道路运输证(副页)</h6>
                </div> -->
                <div class="imgBox">
                    <uploadImg :img='img3'  @remove ='handleRemove3'  @change ='imgPreview3'></uploadImg>
                    <h6>车头照片</h6>
                </div>
                <div class="imgBox">
                  <uploadImg :img='img5' @remove ='handleRemove5' @change ='imgPreview5'></uploadImg>
                  <h6>人车合照</h6>
                </div>

              </div>
            </div>
          </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { cVIadd, cVTlist, cVPlist, cDlist,
  cVElist, getCVehicleInfo, cVhcEnergyTypeList, cVhcNoColourList, getStatementByVchId, listAllVehicleModels, listVehicleLengthsByModelId, getDictionary } from '@/api/vgs-driver2.0'
import { compressImage } from '@/utils/compressImage'
export default {
  name: 'guanlianhetong',
  props: {
    addVehicleFlag: {
      type: Boolean,
      default: false
    },
    goodform: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      addFrom: {
        vehicleClassify1: [],
        vhcPhoto1: '',
        vhcPhoto2: '',
        guaKaoUrl: ''
      },
      importDialog: false,
      isAdd: true,
      title: '添加',
      vehicleL: [],
      vehicleT: [],
      clyt: [],
      pfbz: [],
      vhcType: {},
      vhcL: {},
      ids: [],
      rules: {
        vhcLongNameChang: [
          { required: this.isBitian, message: '请输入长', trigger: 'blur' }
        ],
        vhcLongNamekuan: [
          { required: this.isBitian, message: '请输入宽', trigger: 'blur' }
        ],
        vhcLongNameGao: [
          { required: this.isBitian, message: '请输入高', trigger: 'blur' }
        ],
        vhcNo: [
          { required: true, message: '请输入车牌号', trigger: 'blur' },
          this.rule.vhcNo
        ],
        noColour: [
          { required: true, message: '请选择车牌颜色', trigger: ['blur', 'change'] }
        ],
        vhcCompany: [
          { required: true, message: '请输入所属单位', trigger: 'blur' }
        ],
        vhcCompany1: [
          { required: true, message: '请输入所属个人', trigger: 'blur' }
        ],
        vhcType: [{ required: true, message: '请选择车辆类型', trigger: ['blur', 'change'] }],
        vehicleClassify: [{ required: true, message: '请选择车辆所属', trigger: ['blur', 'change'] }],
        energy: [{ required: true, message: '请选择能源类型', trigger: ['blur', 'change'] }],
        purpose: [{ required: true, message: '请选择使用性质', trigger: ['blur', 'change'] }],
        standards: [{ required: true, message: '请选择排放标准', trigger: ['blur', 'change'] }],
        // drivingLicense: [{ required: true, message: '请输入行驶证号', trigger: 'blur' }],
        vhcQuality: [{ required: this.isBitian, message: '请输入总质量', trigger: 'blur' }],
        weight: [{ required: this.isBitian, message: '请输入载重', trigger: 'blur' }],
        vhcVinNo: [{ required: this.isBitian, message: '请输入车辆识别代号', trigger: 'blur' }],
        vhcEngineNo: [{ required: this.isBitian, message: '请输入发动机号', trigger: 'blur' }],
        transportNo: [{ required: this.isBitian, message: '请输入道路运输证号', trigger: 'blur' }],
        issueAuthority: [{ required: this.isBitian, message: '请输入发证机关', trigger: 'blur' }],
        issueDate: [{ required: this.isBitian, message: '请选择发证日期', trigger: ['blur', 'change'] }],
        drivingExpiringDate: [{ required: this.isBitian, message: '请选择行驶证有效期', trigger: ['blur', 'change'] }],
        businessExpiringDate: [{ required: this.isBitian, message: '请选择运输证有效期', trigger: ['blur', 'change'] }],
        registerDate: [{ required: this.isBitian, message: '请选择注册日期', trigger: ['blur', 'change'] }],
        businessLicenseNo: [{ required: this.isBitian, message: '请输道路运输经营许可证号', trigger: ['blur'] }],
        vehicleTenant: [{ required: this.isBitian, message: '请选择所属单位/个人', trigger: ['blur'] }],
        vehicleTenantName: [{ required: this.isBitian, message: '请所属单位/个人', trigger: ['blur'] }],
        brandModel: [{ required: this.isBitian, message: '请输入车辆品牌', trigger: ['blur'] }],
        trailerNo: [{ required: this.isBitian, message: '请输入挂车牌号', trigger: 'blur' }, this.rule.vhcNoGua],
        vehicleModelId: [{ required: this.isBitian, message: '请选择挂车车型', trigger: 'blur' }],
        vhcLength: [{ required: this.isBitian, message: '请输入车长', trigger: ['blur'] }],
        curbWeight: [{ required: this.isBitian, message: '请输入整备质量', trigger: ['blur'] }],
        scrapTime: [{ required: this.isBitian, message: '请选择行驶证报废日期', trigger: ['blur'] }],
        businessStartTime: [{ required: this.isBitian, message: '请选择行道运证发证日期', trigger: ['blur'] }]
      },
      dialogVisible: false,
      lookImgVisible: false,
      loading: 'false',
      vehicleSS: [
        {
          value: '',
          label: '请选择'
        },
        {
          value: 1,
          label: '单位'
        },
        {
          value: 2,
          label: '个人'
        }
      ],
      NYtype: [],
      cllx: [
        { value: '', label: '请选择' },
        { value: 1, label: '集港' },
        { value: 2, label: '外发' }
      ],
      clys: [],
      ssdw: [], // 所属单位列表
      img: [],
      img1: [],
      img2: [],
      img3: [],
      img4: [],
      img5: [],
      imgList: [null, null, null, null, null],
      newImgFlag: true,
      imgfile: new FormData(),
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e7
        }
      },
      pickerOptionsB: {
        disabledDate (time) {
          return time.getTime() < new Date().setDate(new Date().getDate() - 1)
        }
      },
      trailerNoIsShow: false,
      tableDriveList: [],
      vhcModelList: [],
      vhcLongList: [],
      delImgIds: [],
      isBitian: false,
      bjData: {}
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    cVTlist({}).then(res => {
      this.vehicleT = res
      // this.vehicleT.unshift({ id: '', name: '请选择' })
    })
    cVPlist({}).then(res => {
      this.clyt = res
      this.clyt.unshift({ id: '', name: '请选择' })
    })
    cVElist({}).then(res => {
      this.pfbz = res
      this.pfbz.unshift({ id: '', name: '请选择' })
    })
    cVhcEnergyTypeList({}).then(res => {
      this.NYtype = res
      this.NYtype.unshift({ id: '', energyName: '请选择' })
    })
    cVhcNoColourList({}).then(res => {
      this.clys = res
      this.clys.unshift({ id: '', colourName: '请选择' })
    })
    cDlist({
      pageNo: 1,
      pageSize: 5
    }).then(res => {
      this.tableDriveList = res.list
    })
    listAllVehicleModels().then(res => {
      this.vhcModelList = res
    })
    getDictionary({ groupName: 'certificate_flag' }).then(res => {
      if (res) {
        this.isBitian = res.value1 == 1
      }
    })
  },
  methods: {
    // 获取车辆信息
    CPHfn () {
      if (this.isAdd) {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        this.newImgFlag = false
        getCVehicleInfo({ vhcNo: this.addFrom.vhcNo }).then(res => {
          loading.close()
          if (this.addFrom.id) { // 清空页面
            let vhcNo = this.addFrom.vhcNo
            this.addFrom = {
              vhcNo: vhcNo,
              vehicleClassify1: []
            }
            this.vhcType = {}
            this.vhcL = {}
            this.img = []
            this.img1 = []
            this.img2 = []
            this.img3 = []
            this.img4 = []
            this.img5 = []
            this.newImgFlag = true
          } else {
            this.newImgFlag = true
          }
          if (res.id) {
            this.fuzhi(res)
            this.newImgFlag = true
          }
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }
    },
    // 车辆赋值
    fuzhi (row) {
      this.addFrom = JSON.parse(JSON.stringify(row))

      if (this.addFrom.vehicleClassify == 1) {
        if (row.vehicleTenantCode == '') {
          this.$set(this.addFrom, 'vehicleTenant', row.vehicleTenantName)
        } else {
          this.ssdw = [{ tenantCode: row.vehicleTenantCode, tenantName: row.vehicleTenantName }]
          this.$set(this.addFrom, 'vehicleTenant', { tenantCode: row.vehicleTenantCode, tenantName: row.vehicleTenantName })
        }
      }
      if (row.vhcTypeId) {
        this.$set(this.addFrom, 'vhcType', { id: row.vhcTypeId, name: row.vhcTypeName })
      }
      if (row.noColourId) {
        this.$set(this.addFrom, 'noColour', { id: row.noColourId, name: row.noColourName })
      }
      if (row.energyId) {
        this.$set(this.addFrom, 'energy', { id: row.energyId, name: row.energyName })
      }
      if (row.purposeId == -1) {
        this.$set(this.addFrom, 'purpose', row.purposeName)
      } else {
        this.$set(this.addFrom, 'purpose', { id: row.purposeId, name: row.purposeName })
      }
      this.$set(this.addFrom, 'standards', { id: row.standardsId, name: row.standardsName })
      this.vhcL = { id: row.vhcLongId, name: row.vhcLongName }
      if (row.vhcLongName) {
        let long = this.addFrom.vhcLongName.split('*')
        // console.log(long);
        this.$set(this.addFrom, 'vhcLongNameChang', long[0])
        this.$set(this.addFrom, 'vhcLongNamekuan', long[1])
        this.$set(this.addFrom, 'vhcLongNameGao', long[2])
      }
      if (row.businessStartTime) {
        this.$set(this.addFrom, 'businessStartTime', new Date(row.businessStartTime))
      } else {
        this.$set(this.addFrom, 'businessStartTime', '')
      }
      if (row.scrapTime) {
        this.$set(this.addFrom, 'scrapTime', new Date(row.scrapTime))
      } else {
        this.$set(this.addFrom, 'scrapTime', '')
      }
      if (row.vhcLicense1Url) {
        this.$set(this.img, 0, { status: 'ready', url: row.vhcLicense1Url })
        this.$set(this.imgList, 0, 1)
      }
      if (row.vhcLicense2Url) {
        this.$set(this.img1, 0, { status: 'ready', url: row.vhcLicense2Url })
        this.$set(this.imgList, 1, 1)
      }
      if (row.transportPhotoUrl) {
        this.$set(this.img2, 0, { status: 'ready', url: row.transportPhotoUrl })
        this.$set(this.imgList, 2, 1)
      }
      if (row.vhcPhoto1Url) {
        this.$set(this.img3, 0, { status: 'ready', url: row.vhcPhoto1Url })
        this.$set(this.imgList, 3, 1)
      }
      // if (row.transportPhotoUrl2) {
      //   this.$set(this.img4, 0, { status: 'ready', url: row.transportPhotoUrl2 })
      //   this.$set(this.imgList, 3, 1)
      // }
      if (row.carWithOwnerPhotoUrl) {
        this.$set(this.img5, 0, { status: 'ready', url: row.carWithOwnerPhotoUrl })
        this.$set(this.imgList, 4, 1)
      }
      if (row.vhcTypeName == '重型半挂牵引车' || row.vhcTypeName == '重型全挂牵引车' || row.vhcTypeName == '重型集装箱半挂车' || row.vhcTypeName == '重型集装箱全挂车') {
      	this.trailerNoIsShow = true
      } else {
      	this.trailerNoIsShow = false
      }
    },
    saveFn (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // debuggercon
          console.log((this.addFrom.weight > 0) && (this.addFrom.vhcQuality > this.addFrom.weight))
          if ((this.addFrom.weight < 0) && (this.addFrom.vhcQuality < this.addFrom.weight)) {
            this.$alert('总质量应该大于载重且载重不能为0', '系统提示')
          } else {
            if (this.addFrom.vhcQuality) {
              if (!this.getVhcQualityFlag(this.addFrom.vhcQuality)) { return }
            }
            if (this.addFrom.weight) {
              if (!this.getVhcQualityFlag(this.addFrom.weight)) { return }
            }
            if (this.addFrom.vhcLongNameChang) {
              if (!this.getWaikuoFlag(this.addFrom.vhcLongNameChang)) { return }
            }
            if (this.addFrom.vhcLongNamekuan) {
              if (!this.getWaikuoFlag(this.addFrom.vhcLongNamekuan)) { return }
            }
            if (this.addFrom.vhcLongNameGao) {
              if (!this.getWaikuoFlag(this.addFrom.vhcLongNameGao)) { return }
            }
            if (Number(this.addFrom.vhcLongNameChang) > 99 || Number(this.addFrom.vhcLongNamekuan) > 99 || Number(this.addFrom.vhcLongNameGao) > 99) {
              this.$alert('外廓尺寸整数位不能大于2位', '系统提示')
              return
            }
            if (Number(this.addFrom.vhcQuality) > 99) {
              this.$alert('重量整数位不能大于2位', '系统提示')
              return
            }
            // if (Number(this.addFrom.weight) > 41) {
            //   this.$alert('载重不能大于41吨', '系统提示')
            //   return
            // }
            this.addFrom.vhcClassify = 1
            this.addFrom.vhcTypeName = this.addFrom.vhcType.name
            this.addFrom.vhcTypeId = this.addFrom.vhcType.id
            this.addFrom.vhcTypeCode = this.addFrom.vhcType.code
            this.addFrom.noColourName = this.addFrom.noColour.colourName
            this.addFrom.noColourId = this.addFrom.noColour.id
            this.addFrom.noColourCode = this.addFrom.noColour.colourCode
            this.addFrom.energyName = this.addFrom.energy.energyName
            this.addFrom.energyId = this.addFrom.energy.id
            this.addFrom.energyCode = this.addFrom.energy.energyCode
            if (this.addFrom.vehicleClassify == 1 && this.addFrom.vehicleTenant) {
              if (typeof (this.addFrom.vehicleTenant) == 'string') {
                this.addFrom.vehicleTenantName = this.addFrom.vehicleTenant
                this.addFrom.vehicleTenantCode = ''
              } else {
                this.addFrom.vehicleTenantName = this.addFrom.vehicleTenant.tenantName
                this.addFrom.vehicleTenantCode = this.addFrom.vehicleTenant.tenantCode
              }
            }
            if (this.addFrom.purpose) {
              if (typeof (this.addFrom.purpose) == 'string') {
                this.addFrom.purposeName = this.addFrom.purpose
                this.addFrom.purposeId = -1
              } else {
                if (this.addFrom.purpose.id == '') {
                  this.addFrom.purposeName = null
                } else {
                  this.addFrom.purposeName = this.addFrom.purpose.name
                }
                this.addFrom.purposeId = this.addFrom.purpose.id
              }
            }
            if (this.addFrom.standards) {
              if (this.addFrom.standards.id == '') {
                this.addFrom.standardsName = null
              } else {
                this.addFrom.standardsName = this.addFrom.standards.name
              }
              this.addFrom.standardsId = this.addFrom.standards.id
            }
            if (this.addFrom.vhcLongNameChang && this.addFrom.vhcLongNamekuan && this.addFrom.vhcLongNameGao) {
              this.addFrom.vhcLongName = this.addFrom.vhcLongNameChang + '*' + this.addFrom.vhcLongNamekuan + '*' + this.addFrom.vhcLongNameGao
              this.addFrom.vhcLongId = this.vhcL.id
            }
            this.imgfile.set('params', JSON.stringify(this.addFrom))
            if (this.imgList.length == 5) {
              let arr = []
              for (let i = 0; i < this.imgList.length; i++) {
                if (this.imgList[i]) {
                  if (this.imgList[i] != 1) {
                    arr.push({ img: this.imgList[i], index: i })
                  }
                } else {
                  if (this.isBitian) {
                    this.$alert('请上传证件信息', '系统提示')
                    return
                  } else {
                    arr.push(null)
                  }
                }
              }
              if (arr.length > 0) {
                for (let i = 0; i < arr.length; i++) {
                  let a = i
                  if (arr[i]) {
                    compressImage(arr[i].img.url, arr[i].img.raw, {
                      width: 1000
                    }).then(result => {
                      this.imgfile.append('file' + arr[a].index, result)// result即为压缩后的结果
                      if (a == arr.length - 1) {
                        this.save1()
                      }
                    })
                  } else {
                    if (a == arr.length - 1) {
                      this.save1()
                    }
                  }
                }
              } else {
                this.save1()
              }
            } else if (this.imgList.length == 0) {
              if (this.isBitian) {
                this.$alert('请上传证件信息', '系统提示')
              } else {
                this.save1()
              }
            }
          }
        } else {
          return false
        }
      })
    },
    save1 () {
      var that = this
      const loading = that.$loading({
        lock: true,
        text: '正在处理...'
      })
      cVIadd(that.imgfile).then(res => {
        loading.close()
        that.$message({
          message: '添加成功',
          type: 'success'
        })
        this.$emit('update:addVehicleFlag', false)
        this.$emit('cVIaddFn', res)
      }).catch(error => {
        that.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 车辆类型切换
    vhcTypeChange (e) {
      console.log(e, '车辆类型')
      if (e.name == '重型半挂牵引车' || e.name == '重型全挂牵引车' || e.name == '重型集装箱半挂车' || e.name == '重型集装箱全挂车') {
      	this.trailerNoIsShow = true
      } else {
      	this.trailerNoIsShow = false
      }
    },
    // 所属单位
    remoteMethod (query) {
      console.log(222)
      if (query !== '') {
        selectTenantListByName({ tenantNameLike: query }).then(res => {
          this.ssdw = res
        })
      }
    },
    // 所属切换
    classifyChange () {
      if (this.addFrom.vehicleClassify == 2) {
        this.$set(this.addFrom, 'vehicleTenantName', '')
        this.$set(this.addFrom, 'vehicleTenantCode', '')
      }
    },
    // 图片上传
    handleRemove (data) {
      this.imgList[0] = null
    },
    imgPreview (data) {
      this.imgList[0] = data[0]
    },
    handleRemove1 (data) {
      this.imgList[1] = null
    },
    imgPreview1 (data) {
      this.imgList[1] = data[0]
    },
    handleRemove2 (data) {
      this.imgList[2] = null
    },
    imgPreview2 (data) {
      this.imgList[2] = data[0]
    },
    handleRemove3 (data) {
      this.imgList[3] = null
    },
    imgPreview3 (data) {
      this.imgList[3] = data[0]
    },
    // handleRemove4 (data) {
    //   this.imgList[3] = null
    // },
    // imgPreview4 (data) {
    //   this.imgList[3] = data[0]
    // },
    handleRemove5 (data) {
      // if(data.id){
      //   this.delImgIds.push()
      // }
      this.imgList[4] = null
    },
    imgPreview5 (data) {
      this.imgList[4] = data[0]
    },
    getVhcQualityFlag (str) {
      let index = str.toString().indexOf('.') + 1
      let before = str.toString().substring(0, index - 1)
      // let after = str.substring(index)
      if (before.length > 2) {
        this.$alert('重量小数点前保留2位', '系统提示')
        return false
      }
      return true
    },
    getWaikuoFlag (str) {
      let index = str.toString().indexOf('.') + 1
      let before = str.toString().substring(0, index - 1)
      // let after = str.substring(index)
      if (before.length > 2) {
        this.$alert('外廓尺寸小数点前保留2位', '系统提示')
        return false
      }
      return true
    },
    closeDialog () {
      this.$emit('update:addVehicleFlag', false)
    }

  },
  destroyed () {
  }
}
</script>

<style scoped lang='less'>
.jiaoyan /deep/.el-date-editor {
    width: 150px!important;
}
/deep/.jiaoyan .el-date-editor .el-input__inner {
    width: 150px;
}
.box{
  display: flex;
  justify-content: space-around;
  .imgBox{
    display: flex;
    flex-direction: column;
    width: 386px;
    /deep/.el-upload--picture-card{
          width: 386px;
    height: 240px;
    }
  }
  h6{
    text-align: center;
  }
  .hidden /deep/.el-upload--picture-card{
  display: none;
  }
  /deep/.el-upload--picture-card {
    background-image: url(../../../../assets/images/upload1.png);
  }
  /deep/.el-upload-list--picture-card .el-upload-list__item{
          width: 386px;
    height: 240px;
  }
}
.loogImgBox{
  display: flex;
  justify-content: space-around;
  .box1{
    width: 48%;
  }
  img{
    width: 100%;
  }
}

  /deep/.inpBox .bigInp .el-input__inner{
width: 250px;
}
</style>
